const INTERNAL_HOST_REGEX = [
  /(^|\.)urg\.com\.ar$/i,
  /(^|\.)urgconecta\.com\.ar$/i,
];

function isInternalHost(hostname, currentHost) {
  return hostname === currentHost || INTERNAL_HOST_REGEX.some((rx) => rx.test(hostname));
}

// value es null cuando el param no trae "=" (ej. "?test"); se propaga igual, sin
// agregar el "=" (URLSearchParams.append no distingue este caso, por eso se arma
// el query string a mano en vez de usarlo para serializar).
function encodeParam(key, value) {
  const encodedKey = encodeURIComponent(key);
  return value == null ? encodedKey : `${encodedKey}=${encodeURIComponent(String(value))}`;
}

function collectParams(key, value) {
  return Array.isArray(value)
    ? value.map((item) => encodeParam(key, item))
    : [encodeParam(key, value)];
}

function appendSearch(url, parts) {
  if (parts.length === 0) return;
  const existing = url.search ? url.search.slice(1) : "";
  url.search = existing ? `${existing}&${parts.join("&")}` : parts.join("&");
}

export function mergeRouteQuery(currentQuery = {}, targetQuery = {}) {
  return {
    ...currentQuery,
    ...targetQuery,
  };
}

export function sameRouteQuery(a = {}, b = {}) {
  const normalize = (query) =>
    JSON.stringify(
      Object.keys(query)
        .sort()
        .reduce((acc, key) => {
          const value = query[key];
          acc[key] = Array.isArray(value)
            ? value.map((item) => String(item))
            : value == null
              ? value
              : String(value);
          return acc;
        }, {})
    );

  return normalize(a) === normalize(b);
}

export function withTrackingParams(rawUrl, { query, origin } = {}) {
  if (!rawUrl) return rawUrl;
  if (/^(tel:|mailto:|javascript:|#)/i.test(rawUrl)) return rawUrl;

  const isBrowser = typeof window !== "undefined";
  const baseOrigin = origin ?? (isBrowser ? window.location.origin : "http://localhost");

  let url;
  try {
    url = new URL(rawUrl, baseOrigin);
  } catch (_) {
    return rawUrl;
  }

  const currentHost = new URL(baseOrigin).hostname;

  if (!isInternalHost(url.hostname, currentHost)) {
    return /^https?:\/\//i.test(rawUrl)
      ? url.toString()
      : rawUrl;
  }

  if (query && typeof query === "object") {
    const parts = [];
    Object.entries(query).forEach(([key, value]) => {
      if (url.searchParams.has(key)) return;
      parts.push(...collectParams(key, value));
    });
    appendSearch(url, parts);
  } else if (isBrowser) {
    // Se reusan los fragmentos crudos de window.location.search (en vez de
    // pasarlos por URLSearchParams) para no perder los params sin "=".
    const currentSearch = window.location.search.replace(/^\?/, "");
    const parts = currentSearch
      .split("&")
      .filter(Boolean)
      .filter((pair) => !url.searchParams.has(decodeURIComponent(pair.split("=")[0])));
    appendSearch(url, parts);
  }

  return /^https?:\/\//i.test(rawUrl)
    ? url.toString()
    : `${url.pathname}${url.search}${url.hash}`;
}